import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const ApiKeysApi = {
    getAll: (options?: BaseApiQueryOptions) => apiQueryOptions(['account', 'apiKeys'], (api) => api.apiKeys.getAll(), options),

    create: (options?: BaseApiMutationOptions<ApiClient['apiKeys']['create']>) => apiMutationOptions((api) => api.apiKeys.create, options),
    revoke: (options?: BaseApiMutationOptions<ApiClient['apiKeys']['revoke']>) => apiMutationOptions((api) => api.apiKeys.revoke, options)
};
